<template>
  <d2-container>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
      <el-form ref="elForm" :model="upload.formData" size="medium" label-width="100px">
        <el-form-item label="文书类型" prop="elementTypeId" required>
          <el-select class="filter-item" v-model="upload.formData.elementTypeId" placeholder="请选择">
            <el-option v-for="item in elementTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传" prop="field101" required>
          <el-upload class="upload-demo" ref="upload" :action="uploadAction()" :on-preview="handlePreview"
            :headers="upload.headers" :data="upload.formData" :on-remove="handleRemove" :on-change="changeFileList"
            :http-request="HttpUploadFile" name="fields" :file-list="upload.fileList" :auto-upload="false" :limit="15"
            multiple accept=".pdf">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload"
              v-loading="upload.isUploading">上传到服务器</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传pdf文件，且不超过20MB
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>

    <template slot="header">
      <el-input @keyup.enter.native="handleFilter" style="width: 200px; margin-right: 20px" class="filter-item"
        placeholder="输入搜索内容" v-model="listQuery.content" size="small">
      </el-input>

      <el-select class="filter-item" v-model="listQuery.elementTypeId" placeholder="请选择">
        <el-option v-for="item in elementTypeOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <el-button class="filter-item" style="width:100px;margin-left:30px" type="primary" icon="search"
        @click="handleFilter" size="small">搜索</el-button>
    </template>
    <el-button class="filter-item" style="margin-left: 10px" @click="centerDialogVisible = true" type="primary"
      size="mini" icon="el-icon-circle-plus">上传文件</el-button>

    <el-button class="filter-item" style="margin-left: 10px" @click="download" type="primary" size="mini"
      icon="el-icon-circle-plus">导出要素Excel</el-button>

    <el-button class="filter-item" type="primary" size="mini" @click="pdfdialogVisible = true">PDF拆分</el-button>

    <el-table :key="tableKey" :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row
      style="width: 100%; margin-top: 20px" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50">
      </el-table-column>
      <el-table-column align="center" label="序号" width="65">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="文书类型">
        <template slot-scope="scope">
          <span>{{ exChangeOption(scope.row.elementTypeId) }}</span>
        </template>
      </el-table-column>
      <el-table-column width="110" align="center" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0" style="color:blue"><i class="el-icon-loading">识别中</i></span>
          <span v-if="scope.row.status === 1" style="color:green">已识别</span>
          <span v-if="scope.row.status === 2" style="color:red">识别失败</span>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="识别内容">
        <template slot-scope="scope">
          <span>
            <el-button type="text" @click="showConentDialog(scope.row)">点击查看</el-button>
          </span>
        </template>
      </el-table-column>

      <el-table-column width="250" align="center" label="案件标识">
        <template slot-scope="scope">
          <span>{{ scope.row.caseMessage }}</span>
        </template>
      </el-table-column>
      <el-table-column width="180" align="center" label="文件名称">
        <template slot-scope="scope">
          <span>{{ scope.row.fileName }}</span>
        </template>
      </el-table-column>
      <el-table-column width="220" align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="350" fixed="right">
        <template slot-scope="scope">
          <el-button v-permission:function="['userManager:btn_edit']" size="small" type="success"
            @click="getElementList(scope.row.id)">查看要素
          </el-button>
          <el-dropdown @command="handleCommand" style="margin-left:5px">
            <el-button type="primary" size="small">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(scope.$index, scope.row, 'reIdentify')">OCR识别
              </el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(scope.$index, scope.row, 'reExtract')">要素识别
              </el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(scope.$index, scope.row, 'delete')">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div v-show="!listLoading" class="pagination-container"> -->
    <template slot="footer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </template>

    <el-dialog title="识别内容" :visible.sync="contentDialogVisible" width="100%">
      <el-row :gutter="24">
        <el-col :span="12">
          <div>
            <el-button-group>
              <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>
              <el-button type="primary" size="mini" @click="nextPage">下一页<i
                  class="el-icon-arrow-right el-icon--right"></i></el-button>
            </el-button-group>
            <div style="marginTop: 10px; color: #409EFF">{{ pdf.pageNum }} / {{ pdf.pageTotalNum }}</div>
            <pdf :page="pdf.pageNum" :src="pdf.url" @progress="pdf.loadedRatio = $event"
              @num-pages="pdf.pageTotalNum = $event"></pdf>
          </div>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" style="float:left;margin-bottom: 10px;"
            @click="textareaIsReadOnly = false">编辑</el-button>
          <el-button type="primary" style="float:left;margin-bottom: 10px;"
            @click="updateTextareaContent()">更新</el-button>
          <el-input ref="dialogContentTextarea" type="textarea" :rows="50" placeholder="请输入内容" v-model="dialogContent"
            :readonly=textareaIsReadOnly></el-input>
        </el-col>
      </el-row>

    </el-dialog>

    <el-dialog title="识别要素列表" :visible.sync="elementDialogVisible" width="100%">
      <el-row>
        <el-col :span="10">
          <div>
            <el-button-group>
              <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>
              <el-button type="primary" size="mini" @click="nextPage">下一页<i
                  class="el-icon-arrow-right el-icon--right"></i></el-button>
            </el-button-group>
            <div style="marginTop: 10px; color: #409EFF">{{ pdf.pageNum }} / {{ pdf.pageTotalNum }}</div>
            <pdf :page="pdf.pageNum" :src="pdf.url" @progress="pdf.loadedRatio = $event"
              @num-pages="pdf.pageTotalNum = $event"></pdf>
          </div>
        </el-col>
        <el-col :span="11">
          <template>
            <el-table :data="elementList">
              <el-table-column prop="elementName" label="要素名称" width="200">
                <template slot-scope="scope">
                  <el-tag>{{ scope.row.elementName }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="elementValue" label="要素值" min-width="400" type:html>
                <template slot-scope="scope">
                  {{ scope.row.elementValue }}
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-col>
      </el-row>

    </el-dialog>


    <el-dialog title="拆分PDF" :visible.sync="pdfdialogVisible" width="30%">
      <el-form ref="pdfForm" :model="pdf.formData" size="medium" label-width="100px">
        <el-form-item label="分割页数" prop="splitPage">
          <el-input v-model="pdf.splitPage" placeholder="输入按几页分割"></el-input>
        </el-form-item>
        <el-form-item label="上传PDF" prop="field101" required>
          <el-upload class="upload-demo" ref="pdfUpload" :action="pdfAction()" :on-preview="handlePreview"
            :headers="upload.headers" :data="pdf.formData" :on-remove="handleRemove" :on-change="changeFileList"
            :http-request="HttpPdfUploadFile" name="file" :file-list="upload.fileList" :auto-upload="false" :limit="1"
            multiple accept=".pdf">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px" size="small" type="success" @click="pdfUpload"
              v-loading="upload.isUploading">上传到服务器</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传pdf文件，且不超过20MB
            </div>
          </el-upload>
        </el-form-item>

      </el-form>
    </el-dialog>

    <!-- </div> -->
  </d2-container>
</template>

<script>
import { upload, page, elementList, deleteRecord, renewIdentify, previewPdf, renewExtract, updateContent } from "@/api/sysTool/upload/index";
import { initOptions } from "@/api/sysTool/regex/index";
import util from "@/libs/util";
import { mapGetters } from "vuex";
import pdf from 'vue-pdf';
import axios from 'axios';

export default {
  name: "uploadManager",
  components: {
    pdf
  },
  data() {
    return {
      //上传对话框
      centerDialogVisible: false,
      //识别内容对话框
      contentDialogVisible: false,
      //识别内容对话框ID
      contentDialogId: undefined,
      //识别内容框自读
      textareaIsReadOnly: true,
      //识别内容
      dialogContent: undefined,
      //要素列表
      elementList: undefined,
      //要素对话框
      elementDialogVisible: undefined,
      //pdf上传对话框
      pdfdialogVisible: false,
      //文书种类options
      elementTypeOptions: [],
      //上传接口表单
      fileData: "",
      //页面加载状态
      fullscreenLoading: false,
      ids: [],
      upload: {
        isUploading: false,
        fileList: [],
        formData: {
          elementTypeId: undefined,
        },
        headers: {
          Authorization: util.cookies.get("token"),
        },
      },

      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        content: undefined,
        elementTypeId: undefined
      },
      pdf: {
        //预览PDFURL
        url: undefined,
        //预览页数
        pageNum: 1,
        //预览总页数
        pageTotalNum: 1,
        loadedRatio: 0,
        //上传需要分割的PDF表单
        formData: undefined,
        //文件列表，限一个
        fileList: [],
        //文件
        fileData: "",
        //pdf分割页数
        splitPage: undefined
      },
      textMap: {
        update: "编辑",
        create: "创建",
      },
      tableKey: 0,
    };
  },
  created() {
    this.getList();
    this.initElementTypeOptions();
  },
  computed: {
    ...mapGetters(["elements"]),
  },

  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 20) {
        return value.slice(0, 20) + "...";
      }
      return value;
    }
  },
  methods: {
    submitUpload() {
      //创建FormData对象，用于携带数据传递到后端
      this.fileData = new FormData();
      this.$refs.upload.submit();
      this.fileData.append("elementTypeId", this.upload.formData.elementTypeId);
      var i = this.upload.fileList.length;
      if (i !== 0) {
        //此处执行调用发送请求
        this.upload.isUploading = true;
        upload(this.fileData)
          .then((res) => {
            this.upload.isUploading = false;
            this.upload.fileList = [];
            //this.$message(res.message);
            this.$message({
              message: res,
              type: 'success'
            });

            this.getList()
            centerDialogVisible = false;
          })
          .catch((res) => {
            this.getList()
            this.upload.isUploading = false;
          });
      } else {
        //如果没有文件要上传在此处写逻辑
      }
    },
    pdfUpload() {
      //创建FormData对象，用于携带数据传递到后端
      this.pdf.fileData = new FormData();
      this.$refs.pdfUpload.submit();
      var i = this.pdf.fileList.length;

      //此处执行调用发送请求
      this.upload.isUploading = true;
      const token = util.cookies.get('token')
      axios({
        url: process.env.VUE_APP_API + '/api/ocr/pdfSplit',
        method: 'post',
        data: this.pdf.fileData,
        dataType: 'json',
        responseType: 'blob',
        headers: {
          // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
          authorization: 'Bearer ' + token
        }
      }).then((res) => {
        this.upload.isUploading = false;
        const { data } = res
        const blob = new Blob([data])
        let disposition = decodeURI(res.headers['content-disposition'])
        // 从响应头中获取文件名称
        let fileName = "pdf.zip"
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      }).catch((error) => {
        console.log(error)
      })

    },

    HttpUploadFile(file) {
      this.fileData.append("fields", file.file); // append增加数据
    },
    HttpPdfUploadFile(file) {
      this.pdf.fileData.append("file", file.file); // append增加数据
      this.pdf.fileData.append("splitPage", this.pdf.splitPage);
    },
    //上传路径
    uploadAction() {
      return process.env.VUE_APP_API + "/api/ocr/ocrRecord/upload";
    },
    pdfAction() {
      return process.env.VUE_APP_API + "/api/ocr/pdfSplit";
    },
    //fileList长度改变时触发
    changeFileList(file, fileList) {
      this.upload.fileList = fileList;
    },
    getList() {
      this.listLoading = true;
      page(this.listQuery).then((response) => {
        this.list = response.rows;
        this.total = response.total;
        this.listLoading = false;
      });
    },
    //获取要素列表
    getElementList(ocrRecordId) {
      elementList({ 'ocrRecordId': ocrRecordId }).then(res => {
        this.elementList = res;
        this.elementDialogVisible = true;
      })
      previewPdf(ocrRecordId).then(res => {
        this.pdf.url = res.replace('http', 'https');
      })
    },
    // 重新封装对象，加入参数
    beforeHandleCommand(index, row, command) {
      return {
        'index': index,
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      console.log("command")
      switch (command.command) {
        case "reIdentify"://重新OCR识别
          this.reIdentify(command.row.id);
          break;
        case "reExtract"://重新要素提取识别
          this.reExtract(command.row.id);
          break;
        case "delete":
          this.handleDelete(command.row.id);
          break;
      }
    },
    //重新OCR识别
    reIdentify(id) {

      this.openFullScreen1()
      renewIdentify(id).then(res => {
        this.fullscreenLoading = false;
        this.getList();
        this.$message({
          message: "成功加入OCR识别队列",
          type: 'success'
        });
      })

    },
    //重新要素提取识别
    reExtract(id) {
      this.openFullScreen1()
      renewExtract(id).then(res => {
        this.fullscreenLoading = false;
        this.getList();
        this.$message({
          message: "成功加入要素识别队列",
          type: 'success'
        });
      })
    },
    //更新识别内容
    updateTextareaContent() {
      updateContent(this.contentDialogId, this.dialogContent).then(res => {
        this.$message({
          message: '更新成功',
          type: 'success'
        });
      })
    },
    showConentDialog(row) {
      previewPdf(row.id).then(res => {
        this.pdf.url = res;
        this.pdf.url = this.pdf.url.replace('http', 'https')
      })
      this.dialogContent = row.content;
      this.contentDialogVisible = true;
      this.contentDialogId = row.id;
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleDelete(id) {
      this.$confirm('此操作将删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRecord(id).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList()
        })
      })
    },

    initElementTypeOptions() {
      var that = this;
      initOptions().then((res) => {
        that.elementTypeOptions = res;
      });
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    // 上一页
    prePage() {
      let page = this.pdf.pageNum
      page = page > 1 ? page - 1 : this.pdf.pageTotalNum
      this.pdf.pageNum = page
    },

    // 下一页
    nextPage() {
      let page = this.pdf.pageNum
      page = page < this.pdf.pageTotalNum ? page + 1 : 1
      this.pdf.pageNum = page
    },
    exChangeOption(id) {
      var jsonobj = eval(this.elementTypeOptions);
      for (var i in jsonobj) {
        if (id === jsonobj[i].value) {
          return jsonobj[i].label;
        }
      }
    },
    handleSelectionChange(val) {
      let arr = [];
      for (let item of val) {
        arr.push(item.id)
      }
      this.ids = arr;
    },
    download() {
      if (this.ids.length == 0) {
        this.$message({
          message: '请勾选数据',
          type: 'warning'
        });
        return;
      }
      const token = util.cookies.get('token')
      axios({
        url: process.env.VUE_APP_API + '/api/ocr/ocrRecord/exportExcel',
        method: 'post',
        data: this.ids,
        dataType: 'json',
        responseType: "arraybuffer",
        headers: {
          // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
          authorization: 'Bearer ' + token
        }
      }).then(res => {
        let url = window.URL.createObjectURL(new Blob([res.data], { type: '.xls' }));
        let a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.setAttribute('download', `excel.xls`);
        document.body.appendChild(a);
        a.click();
        url = window.URL.revokeObjectURL(url);
        document.body.removeChild(a)
      }).catch(error => {
      })
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    openFullScreen1() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    }

  },
};

</script>
<style></style>
